import React from 'react';
import tablePng from 'images/content/tablepng.png'

const EighthSection = () => {
    return (
        <>
            <div className='flex flex-col lg:flex-row justify-center lg:justify-between items-center gap-8'>
                <div className='w-full max-w-xl space-y-4'>
                    <div className='text-2xl sm:text-4xl font-bold'>A Better Alternative to Traditional Insurance</div>
                    <div className='space-y-4 sm:text-lg'>
                        <p className='font-bold'>We differ from the Affordable Care Act (Obamacare)</p>
                        <p>Our affordable family health insurance plan provides full medical benefits. It may differ from what you are accustomed to because we created a comprehensive package with lower rates. While insurance providers have increased many of their rates by as much as 100% from 2017 to 2018, we provide alternative solutions for similar benefits with more affordable rates.</p>
                        <p>As a private exchange broker, we have multiple plans available from multiple insurance companies that you can choose from. Simply undergo a routine underwriting process to see if you qualify.</p>
                    </div>
                </div>
                <div className='size-full flex justify-center'>
                    <img className='w-full size-5/6' src={tablePng} alt='plans' />
                </div>
            </div>
        </>
    );
}

export default EighthSection;
